/* tslint:disable */
/* eslint-disable */
/**
 * OnData.SecureFile
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddFileTagInput
 */
export interface AddFileTagInput {
    /**
     * 
     * @type {string}
     * @memberof AddFileTagInput
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AnalyzerDiscoveryInput
 */
export interface AnalyzerDiscoveryInput {
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'orgCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'softwareId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryInput
     */
    'softwareVersion'?: string | null;
    /**
     * 
     * @type {JsonWebKeySet}
     * @memberof AnalyzerDiscoveryInput
     */
    'jwks'?: JsonWebKeySet;
}
/**
 * 
 * @export
 * @interface AnalyzerDiscoveryResponseDto
 */
export interface AnalyzerDiscoveryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'sessionId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'sessionExpireInHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'dataManagerEncryptedKey'?: string | null;
    /**
     * 
     * @type {Array<AnalyzerServiceInfoDto>}
     * @memberof AnalyzerDiscoveryResponseDto
     */
    'dataAnalyzerInfoList'?: Array<AnalyzerServiceInfoDto> | null;
}
/**
 * 
 * @export
 * @interface AnalyzerServiceInfoDto
 */
export interface AnalyzerServiceInfoDto {
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerEncryptedKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerPublicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyzerServiceInfoDto
     */
    'dataAnalyzerEndpoint'?: string | null;
}
/**
 * 
 * @export
 * @interface BaseInfoTypeResponseDto
 */
export interface BaseInfoTypeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BaseInfoTypeResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseInfoTypeResponseDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface BulkUpdateFileInput
 */
export interface BulkUpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'fileIds'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkUpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface CheckPermissionResponseDto
 */
export interface CheckPermissionResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckPermissionResponseDto
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckPermissionResponseDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface ClassificationRuleDto
 */
export interface ClassificationRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleDto
     */
    'activeRule'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleDto
     */
    'predecessorId'?: number | null;
}
/**
 * 
 * @export
 * @interface ClassificationRuleInput
 */
export interface ClassificationRuleInput {
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'targetClassification'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {number}
     * @memberof ClassificationRuleInput
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof ClassificationRuleInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClassificationRuleInput
     */
    'activeRule'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CustomKeyVaultDto
 */
export interface CustomKeyVaultDto {
    /**
     * 
     * @type {number}
     * @memberof CustomKeyVaultDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomKeyVaultDto
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultDto
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'tenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'uri'?: string | null;
    /**
     * 
     * @type {CustomKeyVaultStatus}
     * @memberof CustomKeyVaultDto
     */
    'status'?: CustomKeyVaultStatus;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultDto
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface CustomKeyVaultInput
 */
export interface CustomKeyVaultInput {
    /**
     * 
     * @type {CloudProvider}
     * @memberof CustomKeyVaultInput
     */
    'cloudProvider'?: CloudProvider;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'tenantId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'clientSecret'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomKeyVaultInput
     */
    'uri': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CustomKeyVaultStatus {
    Init = 0,
    InProgress = 1,
    Success = 2,
    Failed = 3
}

/**
 * 
 * @export
 * @interface DataManagerConfigDto
 */
export interface DataManagerConfigDto {
    /**
     * 
     * @type {boolean}
     * @memberof DataManagerConfigDto
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DataManagerConfigDto
     */
    'scanIntervalHours'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataManagerConfigDto
     */
    'scanRootFolders'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface DetectPattern
 */
export interface DetectPattern {
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DetectPattern
     */
    'score'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetectPattern
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentKeywordRule
 */
export interface DocumentKeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentKeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentKeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentKeywordRule
     */
    'isRequired'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DocumentKeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @interface DocumentTypeInput
 */
export interface DocumentTypeInput {
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeInput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeInput
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<DocumentKeywordRule>}
     * @memberof DocumentTypeInput
     */
    'keywordRules'?: Array<DocumentKeywordRule> | null;
}
/**
 * 
 * @export
 * @interface DocumentTypeResponseDto
 */
export interface DocumentTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentTypeResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTypeResponseDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {Array<DocumentKeywordRule>}
     * @memberof DocumentTypeResponseDto
     */
    'keywordRules'?: Array<DocumentKeywordRule> | null;
}
/**
 * 
 * @export
 * @interface DrmSettingDto
 */
export interface DrmSettingDto {
    /**
     * 
     * @type {boolean}
     * @memberof DrmSettingDto
     */
    'drmAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigTenantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigClientId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DrmSettingDto
     */
    'ssoConfigClientSecret'?: string | null;
}
/**
 * 
 * @export
 * @interface EmailTargetDto
 */
export interface EmailTargetDto {
    /**
     * 
     * @type {number}
     * @memberof EmailTargetDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmailTargetDto
     */
    'lastName'?: string | null;
}
/**
 * 
 * @export
 * @interface EncryptFileInput
 */
export interface EncryptFileInput {
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'unencryptedHash': string;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileInput
     */
    'keyContent': string;
}
/**
 * 
 * @export
 * @interface EncryptFileResponseDto
 */
export interface EncryptFileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptFileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EncryptFileResponseDto
     */
    'fileAuditId'?: number;
}
/**
 * 
 * @export
 * @interface EncryptionKeyResponseDto
 */
export interface EncryptionKeyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EncryptionKeyResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof EncryptionKeyResponseDto
     */
    'modifiedTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EncryptionKeyResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface ExcessiveDecryptSettingDto
 */
export interface ExcessiveDecryptSettingDto {
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingDto
     */
    'timeRange'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingDto
     */
    'threshold'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'customRoles'?: Array<number> | null;
    /**
     * 
     * @type {Array<EmailTargetDto>}
     * @memberof ExcessiveDecryptSettingDto
     */
    'users'?: Array<EmailTargetDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExcessiveDecryptSettingDto
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ExcessiveDecryptSettingInput
 */
export interface ExcessiveDecryptSettingInput {
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingInput
     */
    'timeRange': number;
    /**
     * 
     * @type {number}
     * @memberof ExcessiveDecryptSettingInput
     */
    'threshold': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'roles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'customRoles'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExcessiveDecryptSettingInput
     */
    'users'?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExcessiveDecryptSettingInput
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ExclusionRule
 */
export interface ExclusionRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ExclusionRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExclusionRule
     */
    'excludeInfoTypes'?: Array<string> | null;
    /**
     * 
     * @type {KeywordRule}
     * @memberof ExclusionRule
     */
    'excludeByKeyword'?: KeywordRule;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDto
 */
export interface FileAuditResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'timeStamp'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceFileId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceFileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstancePath'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceMachine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDto
     */
    'sourceInstanceUserId'?: number;
}
/**
 * 
 * @export
 * @interface FileAuditResponseDtoPaginationResult
 */
export interface FileAuditResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileAuditResponseDto>}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'items'?: Array<FileAuditResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileAuditResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileInstanceResponseDto
 */
export interface FileInstanceResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'lastModified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FileInstanceResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileInstanceResponseDto
     */
    'parentFileName'?: string | null;
}
/**
 * 
 * @export
 * @interface FileInstanceResponseDtoPaginationResult
 */
export interface FileInstanceResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileInstanceResponseDto>}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'items'?: Array<FileInstanceResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileInstanceResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileKeyResponseDto
 */
export interface FileKeyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FileKeyResponseDto
     */
    'key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileKeyResponseDto
     */
    'fileOfflineId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FileKeyResponseDto
     */
    'fileNameChanged'?: boolean;
}
/**
 * 
 * @export
 * @interface FileOperationInput
 */
export interface FileOperationInput {
    /**
     * 
     * @type {number}
     * @memberof FileOperationInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileOperationInput
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface FileResponseDto
 */
export interface FileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'unencryptedHash'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'encryptionKeyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'parentFileId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'parentFileName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'parentFileDeleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof FileResponseDto
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDto
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FileResponseDto
     */
    'encryptedByUser'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface FileResponseDtoPaginationResult
 */
export interface FileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileResponseDto>}
     * @memberof FileResponseDtoPaginationResult
     */
    'items'?: Array<FileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface FileTagResponseDto
 */
export interface FileTagResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileTagResponseDto
     */
    'tagId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileTagResponseDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface FileViewResponseDto
 */
export interface FileViewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'instanceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileViewResponseDto
     */
    'timeStamp'?: string;
}
/**
 * 
 * @export
 * @interface FileViewResponseDtoPaginationResult
 */
export interface FileViewResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<FileViewResponseDto>}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'items'?: Array<FileViewResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof FileViewResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface InfoTypeInput
 */
export interface InfoTypeInput {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeInput
     */
    'baseInfoType'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeInput
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeInput
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeInput
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeInput
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
}
/**
 * 
 * @export
 * @interface InfoTypeResponseDto
 */
export interface InfoTypeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoTypeResponseDto
     */
    'baseInfoType'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InfoTypeResponseDto
     */
    'isBuiltIn'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InfoTypeResponseDto
     */
    'denyList'?: Array<string> | null;
    /**
     * 
     * @type {Array<DetectPattern>}
     * @memberof InfoTypeResponseDto
     */
    'detectPatterns'?: Array<DetectPattern> | null;
    /**
     * 
     * @type {Array<KeywordRule>}
     * @memberof InfoTypeResponseDto
     */
    'keywordRules'?: Array<KeywordRule> | null;
    /**
     * 
     * @type {Array<ExclusionRule>}
     * @memberof InfoTypeResponseDto
     */
    'exclusionRules'?: Array<ExclusionRule> | null;
}
/**
 * 
 * @export
 * @interface JsonWebKey
 */
export interface JsonWebKey {
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'alg'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'crv'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'd'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'dq'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'e'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'k'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'key_ops'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'kty'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'n'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'oth'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'p'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'q'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'qi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'use'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonWebKey
     */
    'x5c'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5t#S256'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'x5u'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JsonWebKey
     */
    'y'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JsonWebKey
     */
    'keySize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonWebKey
     */
    'hasPrivateKey'?: boolean;
}
/**
 * 
 * @export
 * @interface JsonWebKeySet
 */
export interface JsonWebKeySet {
    /**
     * 
     * @type {Array<JsonWebKey>}
     * @memberof JsonWebKeySet
     */
    'keys'?: Array<JsonWebKey> | null;
}
/**
 * 
 * @export
 * @interface KeywordRule
 */
export interface KeywordRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof KeywordRule
     */
    'words'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof KeywordRule
     */
    'regex'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowBefore'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'windowAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof KeywordRule
     */
    'scoreAdjustment'?: number;
}
/**
 * 
 * @export
 * @interface OfflineFileInput
 */
export interface OfflineFileInput {
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'combId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'fileOfflineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileInput
     */
    'publicKey': string;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessCountMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessBeginTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileInput
     */
    'accessEndTime'?: number;
}
/**
 * 
 * @export
 * @interface OfflineFileResponseDto
 */
export interface OfflineFileResponseDto {
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'offlineFileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'machine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessBeginTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessEndTime'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessCountMax'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDto
     */
    'accessCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineFileResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface OfflineFileResponseDtoPaginationResult
 */
export interface OfflineFileResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<OfflineFileResponseDto>}
     * @memberof OfflineFileResponseDtoPaginationResult
     */
    'items'?: Array<OfflineFileResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface OfflineFileSearchInput
 */
export interface OfflineFileSearchInput {
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfflineFileSearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineFileSearchInput
     */
    'completed'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileSearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfflineFileSearchInput
     */
    'pageIndex'?: number;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDirectivesDto
 */
export interface ProtectionRuleDirectivesDto {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDirectivesDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDirectivesDto
     */
    'ruleDirectiveTree'?: string | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDirectivesQueryResult
 */
export interface ProtectionRuleDirectivesQueryResult {
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleDirectivesQueryResult
     */
    'cacheUnchanged'?: boolean;
    /**
     * 
     * @type {Array<ProtectionRuleDirectivesDto>}
     * @memberof ProtectionRuleDirectivesQueryResult
     */
    'ruleDirectives'?: Array<ProtectionRuleDirectivesDto> | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleDto
 */
export interface ProtectionRuleDto {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'ruleId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'displayName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'ruleDisplayTree'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleDto
     */
    'createTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProtectionRuleDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleDto
     */
    'predecessorId'?: number | null;
}
/**
 * 
 * @export
 * @interface ProtectionRuleInput
 */
export interface ProtectionRuleInput {
    /**
     * 
     * @type {number}
     * @memberof ProtectionRuleInput
     */
    'ruleId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'ruleDisplayTree': string;
    /**
     * 
     * @type {string}
     * @memberof ProtectionRuleInput
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface ReadFileInput
 */
export interface ReadFileInput {
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'combId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'machine': string;
    /**
     * 
     * @type {string}
     * @memberof ReadFileInput
     */
    'publicKey': string;
    /**
     * 
     * @type {number}
     * @memberof ReadFileInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface RenameFileInput
 */
export interface RenameFileInput {
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'fileKeyId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof RenameFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof RenameFileInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @interface ScannedFile
 */
export interface ScannedFile {
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'fullPath': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'lastModifyTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'length': number;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'crucialHash': string;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'computer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'documentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScannedFile
     */
    'infoTypes'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'prevailedPRuleId': number;
    /**
     * 
     * @type {number}
     * @memberof ScannedFile
     */
    'osfFileId': number;
}
/**
 * 
 * @export
 * @interface SearchInput
 */
export interface SearchInput {
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'term'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'tags'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'primaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchInput
     */
    'secondaryClassifications'?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'startTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'endTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchInput
     */
    'pageIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchInput
     */
    'sortField'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchInput
     */
    'sortAscending'?: boolean;
}
/**
 * 
 * @export
 * @interface SetErrorInput
 */
export interface SetErrorInput {
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileViewId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SetErrorInput
     */
    'fileAuditId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SetErrorInput
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface SettingDto
 */
export interface SettingDto {
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingDto
     */
    'decryptionLegalWarning'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'offlineEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'offlineAutoRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'dataAnalyzerOnpremise'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingDto
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'scanIntervalHours'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SettingDto
     */
    'scanRootFolders'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'maxOfflineTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof SettingDto
     */
    'maxOfflineDays'?: number;
}
/**
 * 
 * @export
 * @interface SettingInput
 */
export interface SettingInput {
    /**
     * 
     * @type {number}
     * @memberof SettingInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'efsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'showLegalWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingInput
     */
    'decryptionLegalWarning'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'offlineEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'offlineAutoRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingInput
     */
    'autoDiscoveryEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SettingInput
     */
    'scanIntervalHours'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SettingInput
     */
    'scanRootFolders'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof SettingInput
     */
    'maxOfflineTimes'?: number;
    /**
     * 
     * @type {number}
     * @memberof SettingInput
     */
    'maxOfflineDays'?: number;
}
/**
 * 
 * @export
 * @interface SsoAccessTokenResponseDto
 */
export interface SsoAccessTokenResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SsoAccessTokenResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SsoAccessTokenResponseDto
     */
    'ssoAccessToken'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateFileInput
 */
export interface UpdateFileInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'primaryClassification'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFileInput
     */
    'secondaryClassificationId'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFileInput
     */
    'tags'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface UploadedAutoEncryptReport
 */
export interface UploadedAutoEncryptReport {
    /**
     * 
     * @type {Array<ScannedFile>}
     * @memberof UploadedAutoEncryptReport
     */
    'scannedFiles'?: Array<ScannedFile> | null;
}
/**
 * 
 * @export
 * @interface WriteFileInput
 */
export interface WriteFileInput {
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'absolutePath': string;
    /**
     * 
     * @type {string}
     * @memberof WriteFileInput
     */
    'machine': string;
    /**
     * 
     * @type {number}
     * @memberof WriteFileInput
     */
    'size'?: number;
}

/**
 * SecureFilesApi - axios parameter creator
 * @export
 */
export const SecureFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost: async (customKeyVaultInput?: CustomKeyVaultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customKeyVaultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/customkeyvaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeBaseinfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/baseinfotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/documenttypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttypesIdDelete', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttypesIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdPatch: async (id: string, documentTypeInput?: DocumentTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeDocumenttypesIdPatch', 'id', id)
            const localVarPath = `/api/dataanalyze/documenttypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesPost: async (documentTypeInput?: DocumentTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/documenttypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdDelete', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdGet', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPatch: async (id: string, infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDataanalyzeInfotypesIdPatch', 'id', id)
            const localVarPath = `/api/dataanalyze/infotypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost: async (infoTypeInput?: InfoTypeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dataanalyze/infotypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(infoTypeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/access/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/audit/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost: async (bulkUpdateFileInput?: BulkUpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/bulkupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet: async (fileId: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet: async (fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdInstancesGet', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}/instances`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }

            if (showDelete !== undefined) {
                localVarQueryParameter['showDelete'] = showDelete;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut: async (fileId: number, updateFileInput?: UpdateFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('apiFilesFileIdPut', 'fileId', fileId)
            const localVarPath = `/api/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOfflinefilesSearchPost: async (offlineFileSearchInput?: OfflineFileSearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/offlinefiles/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offlineFileSearchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost: async (searchInput?: SearchInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingPost: async (settingInput?: SettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost: async (addFileTagInput?: AddFileTagInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/files/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesPost: async (classificationRuleInput?: ClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/classificationrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsClassificationrulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/classificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdPut: async (ruleId: number, classificationRuleInput?: ClassificationRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsClassificationrulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/classificationrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classificationRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/protectionrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesPost: async (protectionRuleInput?: ProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scanreports/protectionrules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(protectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdDelete: async (ruleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsProtectionrulesRuleIdDelete', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/protectionrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdPut: async (ruleId: number, protectionRuleInput?: ProtectionRuleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('apiScanreportsProtectionrulesRuleIdPut', 'ruleId', ruleId)
            const localVarPath = `/api/scanreports/protectionrules/{ruleId}`
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(protectionRuleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/excessive-decrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptPut: async (excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/excessive-decrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(excessiveDecryptSettingInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecureFilesApi - functional programming interface
 * @export
 */
export const SecureFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecureFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsDisablePost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCustomkeyvaultsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomKeyVaultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCustomkeyvaultsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeBaseinfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseInfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeBaseinfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttypesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttypesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttypesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttypesIdPatch(id: string, documentTypeInput?: DocumentTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttypesIdPatch(id, documentTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeDocumenttypesPost(documentTypeInput?: DocumentTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeDocumenttypesPost(documentTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InfoTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesIdPatch(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesIdPatch(id, infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoTypeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataanalyzeInfotypesPost(infoTypeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileViewResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAccessSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileAuditResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesAuditSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesBulkupdatePost(bulkUpdateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdGet(fileId, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileInstanceResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesFileIdPut(fileId, updateFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfflineFileResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSearchPost(searchInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSettingGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSettingGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesSettingPost(settingInput?: SettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesSettingPost(settingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileTagResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTagResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFilesTagsPost(addFileTagInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassificationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesPost(classificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProtectionRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesPost(protectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesRuleIdDelete(ruleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsExcessiveDecryptGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExcessiveDecryptSettingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsExcessiveDecryptGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecureFilesApi - factory interface
 * @export
 */
export const SecureFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecureFilesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsDisablePost(options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsDisablePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomKeyVaultInput} [customKeyVaultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomkeyvaultsGet(options?: any): AxiosPromise<CustomKeyVaultDto> {
            return localVarFp.apiCustomkeyvaultsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeBaseinfotypesGet(options?: any): AxiosPromise<Array<BaseInfoTypeResponseDto>> {
            return localVarFp.apiDataanalyzeBaseinfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesGet(options?: any): AxiosPromise<Array<DocumentTypeResponseDto>> {
            return localVarFp.apiDataanalyzeDocumenttypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDocumenttypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdGet(id: string, options?: any): AxiosPromise<DocumentTypeResponseDto> {
            return localVarFp.apiDataanalyzeDocumenttypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesIdPatch(id: string, documentTypeInput?: DocumentTypeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeDocumenttypesIdPatch(id, documentTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DocumentTypeInput} [documentTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeDocumenttypesPost(documentTypeInput?: DocumentTypeInput, options?: any): AxiosPromise<DocumentTypeResponseDto> {
            return localVarFp.apiDataanalyzeDocumenttypesPost(documentTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesGet(options?: any): AxiosPromise<Array<InfoTypeResponseDto>> {
            return localVarFp.apiDataanalyzeInfotypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdDelete(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesIdPatch(id: string, infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDataanalyzeInfotypesIdPatch(id, infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InfoTypeInput} [infoTypeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: any): AxiosPromise<InfoTypeResponseDto> {
            return localVarFp.apiDataanalyzeInfotypesPost(infoTypeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAccessSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileViewResponseDtoPaginationResult> {
            return localVarFp.apiFilesAccessSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesAuditSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileAuditResponseDtoPaginationResult> {
            return localVarFp.apiFilesAuditSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: any): AxiosPromise<FileResponseDto> {
            return localVarFp.apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {number} [pageSize] 
         * @param {number} [pageIndex] 
         * @param {boolean} [showDelete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: any): AxiosPromise<FileInstanceResponseDtoPaginationResult> {
            return localVarFp.apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileId 
         * @param {UpdateFileInput} [updateFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: any): AxiosPromise<OfflineFileResponseDtoPaginationResult> {
            return localVarFp.apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchInput} [searchInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSearchPost(searchInput?: SearchInput, options?: any): AxiosPromise<FileResponseDtoPaginationResult> {
            return localVarFp.apiFilesSearchPost(searchInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingGet(options?: any): AxiosPromise<SettingDto> {
            return localVarFp.apiFilesSettingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SettingInput} [settingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesSettingPost(settingInput?: SettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiFilesSettingPost(settingInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsGet(options?: any): AxiosPromise<Array<FileTagResponseDto>> {
            return localVarFp.apiFilesTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddFileTagInput} [addFileTagInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: any): AxiosPromise<FileTagResponseDto> {
            return localVarFp.apiFilesTagsPost(addFileTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesGet(options?: any): AxiosPromise<Array<ClassificationRuleDto>> {
            return localVarFp.apiScanreportsClassificationrulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesPost(classificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsClassificationrulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ClassificationRuleInput} [classificationRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesGet(options?: any): AxiosPromise<Array<ProtectionRuleDto>> {
            return localVarFp.apiScanreportsProtectionrulesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesPost(protectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesRuleIdDelete(ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} ruleId 
         * @param {ProtectionRuleInput} [protectionRuleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptGet(options?: any): AxiosPromise<ExcessiveDecryptSettingDto> {
            return localVarFp.apiSettingsExcessiveDecryptGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecureFilesApi - object-oriented interface
 * @export
 * @class SecureFilesApi
 * @extends {BaseAPI}
 */
export class SecureFilesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsDisablePost(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsDisablePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomKeyVaultInput} [customKeyVaultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsEnablePost(customKeyVaultInput?: CustomKeyVaultInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsEnablePost(customKeyVaultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiCustomkeyvaultsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiCustomkeyvaultsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeBaseinfotypesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeBaseinfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttypesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttypesIdDelete(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttypesIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {DocumentTypeInput} [documentTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttypesIdPatch(id: string, documentTypeInput?: DocumentTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttypesIdPatch(id, documentTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DocumentTypeInput} [documentTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeDocumenttypesPost(documentTypeInput?: DocumentTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeDocumenttypesPost(documentTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdDelete(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdGet(id: string, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesIdPatch(id: string, infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesIdPatch(id, infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InfoTypeInput} [infoTypeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiDataanalyzeInfotypesPost(infoTypeInput?: InfoTypeInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiDataanalyzeInfotypesPost(infoTypeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAccessSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAccessSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesAuditSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesAuditSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BulkUpdateFileInput} [bulkUpdateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesBulkupdatePost(bulkUpdateFileInput?: BulkUpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesBulkupdatePost(bulkUpdateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdGet(fileId: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdGet(fileId, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {number} [pageSize] 
     * @param {number} [pageIndex] 
     * @param {boolean} [showDelete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdInstancesGet(fileId: number, pageSize?: number, pageIndex?: number, showDelete?: boolean, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdInstancesGet(fileId, pageSize, pageIndex, showDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileId 
     * @param {UpdateFileInput} [updateFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesFileIdPut(fileId: number, updateFileInput?: UpdateFileInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesFileIdPut(fileId, updateFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OfflineFileSearchInput} [offlineFileSearchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesOfflinefilesSearchPost(offlineFileSearchInput?: OfflineFileSearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesOfflinefilesSearchPost(offlineFileSearchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchInput} [searchInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSearchPost(searchInput?: SearchInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSearchPost(searchInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSettingGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSettingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SettingInput} [settingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesSettingPost(settingInput?: SettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesSettingPost(settingInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddFileTagInput} [addFileTagInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiFilesTagsPost(addFileTagInput?: AddFileTagInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiFilesTagsPost(addFileTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClassificationRuleInput} [classificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesPost(classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesPost(classificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {ClassificationRuleInput} [classificationRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsClassificationrulesRuleIdPut(ruleId: number, classificationRuleInput?: ClassificationRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsClassificationrulesRuleIdPut(ruleId, classificationRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProtectionRuleInput} [protectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesPost(protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesPost(protectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesRuleIdDelete(ruleId: number, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesRuleIdDelete(ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} ruleId 
     * @param {ProtectionRuleInput} [protectionRuleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiScanreportsProtectionrulesRuleIdPut(ruleId: number, protectionRuleInput?: ProtectionRuleInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiScanreportsProtectionrulesRuleIdPut(ruleId, protectionRuleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiSettingsExcessiveDecryptGet(options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiSettingsExcessiveDecryptGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExcessiveDecryptSettingInput} [excessiveDecryptSettingInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecureFilesApi
     */
    public apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput?: ExcessiveDecryptSettingInput, options?: AxiosRequestConfig) {
        return SecureFilesApiFp(this.configuration).apiSettingsExcessiveDecryptPut(excessiveDecryptSettingInput, options).then((request) => request(this.axios, this.basePath));
    }
}


